import React from 'react'
import Topbar from '../../components/topbar/Topbar'
import Bottom from '../../components/Bottom/Bottom'
import { useContext, useRef, useState, useEffect } from "react";
import axiosInstance from '../../config';
import { Link, useNavigate } from "react-router-dom";
import SocialContext from "../../context/SocialContext";
import CollectionsIcon from '@mui/icons-material/Collections';
import Alertjs from '../../components/alert/Alert';
import Progress from '../../components/Progress/Progress'
import { PermMedia, Label, Room, EmojiEmotions, SettingsRemoteTwoTone, Cancel } from "@mui/icons-material"

export default function Sharepost() {
    const navigate = useNavigate();
    const { showalert, setshowalert, setalertType, user, fetchcurrentuserfun, setalertmessage, scrolltoTopfun } = useContext(SocialContext);
    const PF = "https://socialshub.netlify.app/images/";

    // for sharePost
    const [file, setfile] = useState(null);
    const [ret, setret] = useState();

    useEffect(() => {
        if (!window.localStorage.getItem('currentUID')) {
            navigate('/');
        }
        window.document.title='SocialHub - Update Profile';
    }, []);


    useEffect(() => {
        scrolltoTopfun();
    }, [])


    // --------------------***************---------------------
    const [loading, setloading] = useState(false);
    const handleonchange = (e) => {
        const file = e.target.files[0];
        setfile(file);
        previewFile(file);
    }
    const [priviewsource, setpriviewsource] = useState(null);
    const previewFile = (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            setpriviewsource(reader.result);
        }
    }
    const submitfun = async (event) => {
        event.preventDefault();
        if (file == null) {
            setshowalert(true);
            setalertmessage("Please add something and try again");
            setalertType("warning");
            setTimeout(() => {
                setshowalert(false);
            }, 2000);
            return;
        }
        uploadimg(priviewsource);
    }
    const uploadimg = async (base64EncodedImage) => {
        const newPost = {
            userId: user._id,
        }
        if (file) {
            newPost.photo = base64EncodedImage;
        }
        try {
            if (user.cloudinaryID) {
                newPost.cloudinaryID = user.cloudinaryID;
            }

            setloading(true);
            const response = await axiosInstance.put(`api/auth/updateprofile`, newPost);
            setloading(false);
            if (response.data.success) {
                setalertmessage("Account updated successfully");
                setalertType('success');
                setshowalert(true);
                setTimeout(() => {
                    setshowalert(false);
                    navigate(`/profile/${user._id}`);
                }, 2000);
            }
        } catch (error) {
            console.log("inside post error", error);
        }
    }


    return (
        <>
            <Topbar />
            {showalert ? <div style={{ 'height': '48px', 'position': 'sticky', 'top': '50px', 'zIndex': '2' }}>
                <Alertjs />
            </div> : ""}
            {loading ? <div style={{'minHeight':'100vh',backgroundColor:'#dadada',display:'flex','alignItems':'center','justifyContent':'center'}}><Progress /></div> : ''}
            {!loading?<div className="shareContainer">
                <div className='shareBox'>
                    <div className="share sharePost">
                        <h2 style={{ 'textAlign': 'center', color: 'blue' }}>Update Profile Picture</h2>
                        <div className="shareWrapper">
                            {/* share form */}
                            <form className="shareform" style={{ 'display': 'flex', alignItems: 'center', justifyContent: 'center' }} onSubmit={submitfun}>

                                {file && (<div className="shareImgContainer">
                                    <img src={priviewsource} />
                                    <Cancel className='cancleimg' onClick={() => { setfile(null) }} />
                                </div>)}

                                {!file && (<label htmlFor='file' className='sharePhoto'>
                                    <CollectionsIcon style={{ 'color': 'red', 'marginRight': '5px' }} />
                                    <span>Photos</span>
                                    <input
                                        style={{ display: 'none', cursor: 'pointer' }}
                                        type="file"
                                        name="file"
                                        id="file"
                                        accept='.png,.jpeg,.jpg'
                                        value={file}
                                        onChange={(e) => { handleonchange(e) }}
                                    />
                                </label>)}
                                <h5 style={{ 'marginTop': '5px' }}>Drag and Drop or Click To Update Image</h5>
                                <button type="submit" className="postButton">Update</button>
                            </form>
                        </div>
                    </div >
                </div >
            </div>:''}
            <div className="copyright" style={{ 'backgroundColor': '#dadada' }}>
                <p style={{ 'textAlign': 'center', opacity: '0.7' }}>Copyright @2022-Alok.info | All rights reserved</p>
            </div>
            <Bottom />
        </>
    )
}
